import Flickity from "flickity";

export default function timelineSlider() {
  const el = document.querySelector(".timeline-slider");
  if (!el) return;

  const slider = new Flickity(el, {
    pageDots: el.getAttribute('data-pagedots') !== null,
    prevNextButtons: false,
    draggable: true,
    wrapAround:true
  });

  if(document.querySelectorAll('.timeline-slider-button').length === 2) {
    document.querySelector('.timeline-slider-button.prev').addEventListener('click', () => slider.previous());
    document.querySelector('.timeline-slider-button.next').addEventListener('click', () => slider.next());
  }

}